import { SuggestedRow } from '../../SuggestedRow/SuggestedRow'
import suggestedRowClasses from '../../SuggestedRow/SuggestedRow.module.scss'

import { GivingCampaignGroupDto } from '@percent/workplace-giving/api/campaigns/campaign.types'
import { useGivingCampaignGroupRow } from './useGivingCampaignGroupRow'
import { OpportunityCardSkeleton } from '@percent/workplace-giving/common/components/OpportunityCard/OpportunityCardSkeleton'
import { GivingCampaignGroupItemCard } from './GivingCampaignGroupItemCard'
import { Box } from '@percent/lemonade'
import { InfiniteScrollingCarousel } from '@percent/workplace-giving/common/components/InfiniteScrollingCarousel/InfiniteScrollingCarousel'
import classes from './GivingCampaignGroupRow.module.scss'

export function GivingCampaignGroupRow({ group }: { group: GivingCampaignGroupDto }): JSX.Element | null {
  const { campaigns, tilesAmount, isPending, skeletonData, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useGivingCampaignGroupRow(group.id)

  if (isPending) {
    return (
      <SuggestedRow
        title={group.name}
        testId="giving-campaign-group-row-skeleton"
        items={skeletonData}
        keyExtractor={key => key}
        renderItem={() => <OpportunityCardSkeleton />}
      />
    )
  }

  if (campaigns.length === 0) {
    return null
  }

  return (
    <Box className={suggestedRowClasses.SuggestedRowContainer} data-testid="giving-campaign-group-row">
      <InfiniteScrollingCarousel
        title={group.name}
        navWrapperClassName={classes.NavBarWrapper}
        titleClassName={suggestedRowClasses.SuggestedRowTitle}
        headerClassName={suggestedRowClasses.SuggestedRowHeader}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        data={campaigns}
        itemsPerPage={tilesAmount}
        renderItem={c => <GivingCampaignGroupItemCard campaignOverview={c} />}
      />
    </Box>
  )
}
